export default __webpack_public_path__ + "static/media/DharmaGothicE_ExLight_I.dea32c3b.otf";